export default "__VITE_ASSET__Cm806Da4__"